import React from 'react';
import { Badge } from '@/components/ui/badge';

export type StatusType =
  | 'active'
  | 'temporarily_closed'
  | 'permanently_closed'
  | 'under_renovation'
  | 'not_active'
  | string;

export const getStatusBadge = (status: StatusType): React.ReactNode => {
  switch (status) {
    case 'active':
      return <Badge className="bg-green-100 text-green-800">Active</Badge>;
    case 'temporarily_closed':
      return (
        <Badge className="bg-yellow-100 text-yellow-800">
          Temporarily Closed
        </Badge>
      );
    case 'permanently_closed':
      return (
        <Badge className="bg-red-100 text-red-800">Permanently Closed</Badge>
      );
    case 'under_renovation':
      return (
        <Badge className="bg-blue-100 text-blue-800">Under Renovation</Badge>
      );
    case 'not_active':
      return <Badge className="bg-gray-100 text-gray-800">Not Active</Badge>;
    default:
      return <Badge>{status}</Badge>;
  }
};

export const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'temporarily_closed', label: 'Temporarily Closed' },
  { value: 'permanently_closed', label: 'Permanently Closed' },
  { value: 'under_renovation', label: 'Under Renovation' },
  { value: 'not_active', label: 'Not Active' },
];
